import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DialogRef } from 'angular2-modal';

import { SharedJobService } from '../../../shared/services/shared-job.service';

import { default as swal } from 'sweetalert2';
declare var $: any;
declare var tinymce: any;


export class JobDescriptionModalComponent implements OnInit, OnDestroy {
	public state: any;
	public jobDetails: any;

	constructor(
		public dialog: DialogRef<any>,
		private sharedJobService: SharedJobService) { }

	public ngOnInit(): void {
		if (this.checkInitData()) {
			this.getJobDetails();
		}
	}

	public ngOnDestroy(): void {
		if (this.jobDetails['job_description_editor']) {
			tinymce.remove(this.jobDetails['job_description_editor']);
		}
		if (this.jobDetails['job_what_editor']) {
			tinymce.remove(this.jobDetails['job_what_editor']);
		}
	}

	public closeModal(): void {
		this.dialog.close();
	}

	public onSaveClick(): void {
		let dataToSubmit = {};

		if (this.jobDetails.description && this.jobDetails.description.length > 0) {
			dataToSubmit['description'] = this.jobDetails.description;
		}

		if (this.jobDetails.what && this.jobDetails.what.length > 0) {
			dataToSubmit['what'] = this.jobDetails.what;
		}

		this.sharedJobService.setJobDetails(this.dialog.context.initData.clientId, this.dialog.context.initData.jobId, dataToSubmit).subscribe(
			(response) => {
				if (response) {
					// success updating the job details
					swal({
						title: 'Success',
						text: 'The job details has been saved with success!',
						type: 'success',
						showCancelButton: false,
						confirmButtonColor: '#008fb3',
						confirmButtonText: 'Ok',
						allowOutsideClick: false,
						allowEscapeKey: false
					}).then(() => undefined);
				} else {
					this.handleError('Something went wrong on saving the job details!');
				}
			}
		);
	}

	private checkInitData(): boolean {
		let pass: boolean = true;
		if (!this.dialog.context.initData) {
			pass = false;
		}
		if (!this.dialog.context.initData.clientId || !this.dialog.context.initData.jobId) {
			pass = false;
		}
		if (!pass) {
			this.closeModal();
			this.handleError({message: 'The mandatory data is missing!'});
		} else {
			this.state = this.dialog.context.initData;
		}
		return pass;
	}

	private getJobDetails(): void {
		this.sharedJobService.get(this.dialog.context.initData.clientId, this.dialog.context.initData.jobId).subscribe(
			(jDetails) => {
				this.jobDetails = jDetails;
				let intervalId: any = setInterval(() => {
					if ($('#job-description').length > 0 && ('#job-what').length > 0) {
						clearInterval(intervalId);
						intervalId = 0;
						this.renderJobDescriptionEditor();
						this.renderJobWhatEditor();
					}
				}, 1);
			}
		);
	}

	private renderJobDescriptionEditor() {
		tinymce.init({
			selector: '#job-description',
			skin: false,
			plugins: ['paste', 'link', 'autoresize', 'lists', 'preview', 'searchreplace', 'wordcount', 'code', 'insertdatetime', 'contextmenu', 'autoresize'],
			width: '100%',
			height: 300,
			autoresize_min_height: 100,
			autoresize_max_height: 200,
			branding: false,
			setup: (editor) => {
				this.jobDetails['job_description_editor'] = editor;
				this.jobDetails['job_description_editor'].on('keyup', (evt, i) => {
					this.jobDetails.description = this.jobDetails['job_description_editor'].getContent();
				});
			}
		});
	}

	private renderJobWhatEditor() {
		tinymce.init({
			selector: '#job-what',
			skin: false,
			plugins: ['paste', 'link', 'autoresize', 'lists', 'preview', 'searchreplace', 'wordcount', 'code', 'insertdatetime', 'contextmenu', 'autoresize'],
			width: '100%',
			height: 300,
			autoresize_min_height: 100,
			autoresize_max_height: 200,
			branding: false,
			setup: (editor) => {
				this.jobDetails['job_what_editor'] = editor;
				this.jobDetails['job_what_editor'].on('keyup', (evt, i) => {
					this.jobDetails.what = this.jobDetails['job_what_editor'].getContent();
				});
			}
		});
	}

	private handleError(error: any) {
		let errMsg = (error.message) ? error.message :
		error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
	}
static ctorParameters() { return [ { type: DialogRef }, { type: SharedJobService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/modals/job-description/job-description-modal.component.ts